import de from '@shared/assets/locales/de.json'
import en from '@shared/assets/locales/en.json'
import es from '@shared/assets/locales/es.json'
import fr from '@shared/assets/locales/fr.json'
import hu from '@shared/assets/locales/hu.json'
import ja from '@shared/assets/locales/ja.json'
import ru from '@shared/assets/locales/ru.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export function initI18n(): void {
  const resources = {
    en: { translation: en },
    de: { translation: de },
    fr: { translation: fr },
    ru: { translation: ru },
    ja: { translation: ja },
    hu: { translation: hu },
    es: { translation: es },
  }

  i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      compatibilityJSON: 'v4',
      resources,
      fallbackLng: 'en',
      debug: true,

      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    })
}
